<div class="wrapper">
  <bz-input-search-wrapper-field (onClickField)="toSearch()"></bz-input-search-wrapper-field>
  <button class="faq-btn" type="button">?</button>
</div>
